import React from "react";
import "./loading.css"

const Loading = () => {
    return ( 
        <div class="loader" />
     );
}
 
export default Loading;